import React from "react";

const extractYouTubeId = (url) => {
  const match = url?.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/))([^?&]+)/);
  return match ? match[1] : null;
};

const VideoRenderer = ({ url }) => {
  if (!url) return null;

  const youtubeId = extractYouTubeId(url);

  return (
    <div className=" rounded-lg border border-gray-300 p-2 bg-white shadow-md">
      {youtubeId ? (
        <div className="relative pb-[56.25%] rounded-md overflow-hidden">
          <iframe
            src={`https://www.youtube.com/embed/${youtubeId}`}
            title="YouTube Video"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="absolute top-0 left-0 w-full h-full rounded-md"
          />
        </div>
      ) : url.endsWith(".mp4") ? (
        <video controls className="w-full rounded-md">
          <source src={url} type="video/mp4" />
          Dein Browser unterstützt dieses Video nicht.
        </video>
      ) : (
        <div className="text-xs text-gray-500 text-center py-4">
          ⚠️ Unbekanntes Videoformat
        </div>
      )}
    </div>
  );
};

export default VideoRenderer;
